import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                <span>Healthcare Software</span> Development Services
              </h1>
              <p>
                We specialize in implementing advanced digital healthcare
                solutions that optimize patient data using data science,
                blockchain, IoT, and VR/AR/MR technologies. Our goal is to
                empower institutions for a tech-driven future, delivering up to
                99% value.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your App!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
            <StaticImage
              src="../../images/services-usa/healthcare-software/banner_img.webp"
              alt="Healthcare Software Development Company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={667}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
